import React from 'react';
import Loader from 'components/commons/Loader';

class Loading extends React.Component {

    render() {
        return (
            <div style={{
                height: '98vh',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Loader size={200}/>
            </div>
        );
    }
}

export default Loading;
